
export default {
  props: {
    currentViewTitle: {
      required: true,
      type: String,
    },
    edit: {
      required: false,
      default: false,
      type: Boolean,
    },
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
    hideEditButton: {
      required: false,
      default: false,
      type: Boolean,
    },
    hasEdited: {
      required: false,
      default: false,
      type: Boolean,
    },
    onlyToggle: {
      required: false,
      default: true,
      type: Boolean,
    },
    isUserEdit: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  computed: {
    hideTitle() {
      return (
        [
          "Ordredetaljer",
          "Info fordelsprogram",
          "Bli med i fordelsprogram",
          "Poenghistorikk",
          "Vilkår for bruk",
        ].includes(this.currentViewTitle) ||
        (this.layout == "chain" && this.currentViewTitle == "Fordelsprogram") ||
        this.currentViewTitle == "Bli med i fordelsprogram"
      );
    },
    isEditableChain() {
      return [
        "Favorittansatte",
        "Favorittbehandlinger",
        "Favorittprodukter",
      ].includes(this.currentViewTitle);
    },
    isEditablePortal() {
      return (
        this.editableChain ||
        (["Profil", "Mine salonger"].includes(this.currentViewTitle) &&
          this.layout == "portal")
      );
    },
  },
};
